import { AuthServiceProviderV4 } from '@oneaudi/audi-auth-service';
import { ContentServiceV1 } from '@oneaudi/content-service';
import { HistoryServiceV2 } from '@feature-hub/history-service';
import { NotificationDisplayServiceV1 } from '@oneaudi/audi-notification-display-service';
import { SerializedStateManagerV1 } from '@feature-hub/serialized-state-manager';

export interface IntegratorFeatureServices {
  'audi-content-service': ContentServiceV1;
  's2:history': HistoryServiceV2;
  's2:serialized-state-manager': SerializedStateManagerV1;
  'vw:authService': AuthServiceProviderV4;
  'notification-display-service': NotificationDisplayServiceV1;
}

export const featureServiceDependencies: Record<
  keyof IntegratorFeatureServices,
  string
> = {
  'audi-content-service': '^1.0.0',
  's2:history': '^2.0.0',
  's2:serialized-state-manager': '^1.0.0',
  'vw:authService': '^4.0.0',
  'notification-display-service': '^1.0.0',
};
